<template>
    <div class="member-card wow fadeInUp">
        <div class="image-wrap">
            <div class="image-border"></div>
            <a class="image-link"
               :href="memberSlug(member.slug)"
               v-on="!active ? { click: () => showMessage() } : {}"
            >
                <div class="image" :style="setImage(member.logo)"></div>
            </a>
        </div>
        <a
            class="text"
            :href="memberSlug(member.slug)"
            v-on="!active ? { click: () => showMessage() } : {}"
        >
            <h4 class="name">{{ member.referred_first_name }} {{ member.referred_last_name }}</h4>
            <p class="company">{{ member.company_name }}</p>
            <p class="position">{{ member.position }}</p>
            <p class="position">{{ member.generation }}</p>
        </a>
    </div>
</template>

<script>
    export default {
        name: "MembersItem",
        props: {
            member: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                required: true
            }
        },
        methods: {
            memberSlug(slug) {
                if (this.active) return `members/${slug}`

                return `javascript:void(0)`
            },
            showMessage() {
                this.$swal.fire({
                    icon: `warning`,
                    title: `Authentication warning`,
                    text: `Please sign in to see this page!`,
                })
            },
            setImage(image) {
                const memberImage = image ? image : '/uploads/img/fav.png'

                return `background-image: url(${memberImage})`
            }
        }
    }
</script>

<style scoped>

</style>
